// --------------------------------------------------------------------------
// Content tabs
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var $tabContent = context.find('[data-tab]');

    function init() {

        // Add tabs markup
        var $tabControls = $('<div class="tab-controls"></div>');

        // Tab Controls Position
        if (options.tabControlPos === 'bottom') {
            context.append($tabControls);
        } else {
            context.prepend($tabControls);
        }

        function deselectTab() {
            context.find('.tab-controls__link').removeClass('is-selected');
            $tabContent.removeClass('is-visible');
        }

        function selectTab(selectedTab) {
            var tabText = selectedTab.text();
            selectedTab.addClass('is-selected');
            context.find('[data-tab="' + tabText + '"]').addClass('is-visible');
            if ($('.infographic').length) {
                var infographic = context.find('[data-tab="' + tabText + '"]').find('.infographic__chart');
                if (infographic.length > 0) {
                    $(infographic).trigger('tab.hasChanged');
                }
            }
        }

        // Cycle through tabbed content and create tabs
        $tabContent.each(function () {
            var tabTitle = $(this).data('tab');
            var $currentControl = $('<button class="tab-controls__link">' + tabTitle + '</button>');
            $tabControls.append($currentControl);
        });

        if ($('.survey-results-charting-call-to-action').length > 0) {
            var cta = $('.survey-results-charting-call-to-action > a');
            cta.detach().appendTo($tabControls);
        }

        //On load add selected state to first tab and its content
        context.find('.tab-controls__link:first').addClass('is-selected');
        context.find('[data-tab]:first').addClass('is-visible');

        //Click event for tabs to show content
        $tabControls.on('click', '.tab-controls__link', function () {
            deselectTab();
            selectTab($(this));
        });

        //Add accessible display
        context.find('.content-tab *').on({
            focus: function focus() {
                deselectTab();
                var tabText = $(this).parents('.content-tab').data('tab');
                $tabControls.find('.tab-controls__link').each(function () {
                    if ($(this).text() === tabText) {
                        $(this).addClass('is-selected');
                    }
                });
                context.find('[data-tab="' + tabText + '"]').addClass('is-visible');
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/content-tabs.js
// module id = 92
// module chunks = 0